import { defineComponent as c, computed as i, createElementBlock as d, openBlock as m, normalizeClass as f, toDisplayString as b } from "vue";
import { isEmpty as g } from "../../utils/isEmpty.js";
import { tw as a } from "../../utils/tailwind.js";
const v = ["aria-label", "aria-labelledby"], y = /* @__PURE__ */ c({
  name: "RevBadge",
  __name: "Badge",
  props: {
    ariaLabel: { default: () => {
    } },
    ariaLabelledby: { default: () => {
    } },
    count: { default: 0 },
    maxCount: { default: 99 },
    size: { default: "large" },
    variant: { default: "info" }
  },
  setup(e) {
    const n = i(() => e.count === 0 ? null : e.count > e.maxCount ? `${e.maxCount}+` : e.count), s = i(() => !g(n.value)), o = i(() => {
      const t = a`text-static-default-hi rounded-lg caption-bold inline-block max-w-full truncate`, l = a`min-w-20 px-4 text-center`, r = {
        small: a`size-6`,
        medium: a`size-8`,
        large: a`size-12`
      }, u = {
        danger: a`bg-static-danger-hi`,
        warning: a`bg-static-warning-hi`,
        success: a`bg-static-success-hi`,
        info: a`bg-static-info-hi`,
        accent: a`bg-static-info-max`
      };
      return [
        t,
        u[e.variant],
        s.value ? l : r[e.size]
      ];
    });
    return (t, l) => (m(), d("span", {
      "aria-label": t.ariaLabel,
      "aria-labelledby": t.ariaLabelledby,
      "aria-live": "polite",
      class: f(o.value),
      role: "status"
    }, b(n.value), 11, v));
  }
});
export {
  y as default
};
